import { generateID } from './id.js';

const initDocument = (file, type, info) => ({
  id: generateID(),
  file,
  type,
  info
});

export { initDocument };
